import gql from "graphql-tag";

// Ticket Purchase FE Integration Guide, 3 Nov 2026. scope: ALL is passed as
// an inline literal (not a typed variable) so we don't have to guess the
// scope enum's GraphQL type name - it returns standalone tickets by
// default, and ALL also includes tickets bought with a costume.
export const GET_MY_TICKETS = gql`
  query GetMyTickets {
    getMyTickets(scope: ALL) {
      ticketOrderId
      status
      feteName
      feteStartsAt
      total
      currency
      paymentMode
      holdExpiresAt
      lines {
        tierName
        quantity
      }
      event {
        name
        startDate
        venue
        imageUrl
        showQrCode
      }
      tickets {
        ticketId
        tierName
        qrCode
        qrImage
      }
    }
  }
`;
